import { Translation } from '@ps/web-shared-components';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Button from '@swf/components/StarsButton/StarsButton';
import Body from '@swf/components/StarsModal/components/Body';
import CloseButton from '@swf/components/StarsModal/components/CloseButton';
import Header from '@swf/components/StarsModal/components/Header/Header';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import {
  TXTCLI_Contact_Support,
  TXTWCL_Continue_without_logging_in,
  TXTWCL_Help_us_help_youX_login_to_you_ELL,
  TXTWCL_Login_to_chat_with_us
} from './MessengerLogin.messages.json';
import styles from './MessengerLogin.scss';

const MessengerLogin: React.FC = () => {
  const { lpTagMgr } = window;
  const isEmbedded = useSelector(select.device.isEmbedded);
  const {
    modal: { enqueue, close }
  } = useDispatch<Dispatch>();

  const openLoginModal = useCallback(() => {
    enqueue({ path: '/auth/login' });
    if (!isEmbedded) {
      close();
    }
  }, [close, enqueue, isEmbedded]);

  const continueWithoutLogin = () => {
    close();
    lpTagMgr.openChat();
  };

  return (
    <>
      <Header>
        <Translation {...TXTCLI_Contact_Support} />
        <CloseButton />
      </Header>
      <Body>
        <p className={styles.text}>
          <Translation {...TXTWCL_Help_us_help_youX_login_to_you_ELL} />
        </p>
        <Button
          inverse
          variant="primary"
          onClick={openLoginModal}
          translation={TXTWCL_Login_to_chat_with_us}
        />
        <Button
          variant="text"
          block
          onClick={continueWithoutLogin}
          translation={TXTWCL_Continue_without_logging_in}
        />
      </Body>
    </>
  );
};

export default MessengerLogin;
